import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navClose, navOpen } from 'store/legacyActionsBridge';

/**
 * Sol paneli dar (yalnizca ikon) ve genis mod arasinda degistirir.
 * Ust bardaki hamburger ve paneldeki ac/kapa butonu ayni davranisi paylasir.
 */
export const useSidebarToggle = () => {
    const dispatch = useDispatch();
    const isCollapsed = Boolean(useSelector((state: any) => state.sideMenu));

    const toggle = useCallback(() => {
        const shouldCollapse = !isCollapsed;
        document.getElementById('main-wrapper')?.classList.toggle('menu-toggle', shouldCollapse);
        dispatch(shouldCollapse ? navOpen() : navClose());
    }, [dispatch, isCollapsed]);

    return { isCollapsed, toggle };
};
